import {apsEvents} from "../../shared/dto/aps.events";
import * as angular from "angular";
import * as moment from "moment";
import {SignalRHub} from "../hubs/signalr-hub";
import HubServiceName, {HubService} from "../hubs/hub.service";

export interface MorningMinutesReportHubService {
  createMorningMinutesReportHub(updateResult: (report: apsEvents.MorningMinutesReportInstanceAvailable) => void,
                                plantId: string,
                                reportDate: Date,
                                requireNewReport: boolean): MorningMinutesReportHub;
}

export interface MorningMinutesReportHub extends SignalRHub {
  joinGroup(plantId: string): Promise<any>;
  leaveGroup(plantId: string): Promise<any>;
}

export default angular.module('aps.hubs.morningMinutesReports', [HubServiceName])
  .service('morningMinutesReportHubService', function (hubService: HubService): MorningMinutesReportHubService {

    function createMorningMinutesReportHub(updateResult: (report: apsEvents.MorningMinutesReportInstanceAvailable) => void,
                                           plantId: string,
                                           reportDate: Date,
                                           requireNewReport: boolean): MorningMinutesReportHub {
      var reportDay = moment(reportDate).startOf('day').toDate().getTime();

      return hubService.createHub<MorningMinutesReportHub>('morningMinutes', {
        allowMultipleListeners: true,
        listeners: {
          morningMinutesAvailable: function (morningMinutesReportInstanceAvailable: apsEvents.MorningMinutesReportInstanceAvailable) {
            if (morningMinutesReportInstanceAvailable
              && (morningMinutesReportInstanceAvailable.plantId === plantId)
              && moment(morningMinutesReportInstanceAvailable.date).startOf('day').toDate().getTime() === reportDay
              && (!requireNewReport || morningMinutesReportInstanceAvailable.newReportInstance)) {
              updateResult(morningMinutesReportInstanceAvailable);
            }
          }
        },
        methods: ['leaveGroup', 'joinGroup'],
        postConnect: (hub: MorningMinutesReportHub) => {
          return hub.invokeWithRetry(() => hub.joinGroup(plantId));
        }
      });
    }

    return {
      createMorningMinutesReportHub: createMorningMinutesReportHub
    };
  })
  .name;


// WEBPACK FOOTER //
// ./src/app/services/reports/morningMinutesReport.hub.ts